export class Localidade {
  idLocalidade: number = null;
  dsLocalidade: string = null;
  txtSigla: string = null;
  snAtiva: string = null;
  fkCidade: string = null;
  dsNomeCidade: string = null;
  nrCodigoIbge: number = null;
  txtSiglaUf: string = null;
  cdAnterior: number = null;
  txtArea: string = null;
  grau: string = null;
  txtInstancia: string = null;
  cdTpUnid: number = null;
  tipoUnidade: string = null;
  fkSubordinacao: number = null;
  descSubordinacao: string = null;

  constructor(d?) {
    if (d) {
      this.idLocalidade = d.idLocalidade ? d.idLocalidade : null;
      this.dsLocalidade = d.dsLocalidade ? d.dsLocalidade : null;
      this.txtSigla = d.txtSigla ? d.txtSigla : null;
      this.snAtiva = d.snAtiva ? d.snAtiva : null;
      this.fkCidade = d.fkCidade ? d.fkCidade : null;
      this.dsNomeCidade = d.dsNomeCidade ? d.dsNomeCidade : null;
      this.nrCodigoIbge = d.nrCodigoIbge ? d.nrCodigoIbge : null;
      this.txtSiglaUf = d.txtSiglaUf ? d.txtSiglaUf : null;
      this.cdAnterior = d.cdAnterior ? d.cdAnterior : null;
      this.txtArea = d.txtArea ? d.txtArea : null;
      this.grau = d.grau ? d.grau : null;
      this.txtInstancia = d.txtInstancia ? d.txtInstancia : null;
      this.cdTpUnid = d.cdTpUnid ? d.cdTpUnid : null;
      this.tipoUnidade = d.tipoUnidade ? d.tipoUnidade : null;
      this.fkSubordinacao = d.fkSubordinacao ? d.fkSubordinacao : null;
      this.descSubordinacao = d.descSubordinacao ? d.descSubordinacao : null;
    }
  }
}
